import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import './bic-loader.css'

const BIC_FORM_MODAL = 'BICFormModal'

const BICFormModal = Loadable(() => import('./BICForm'))

export const createBICNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'pay',
  text: translateFn('mnu_credit_purchase'),
  identity: BIC_FORM_MODAL,
  permission: 'BIC_WIZARD',
  component: BICFormModal,
}))
